import { format, isSameDay, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const parseDateValue = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const parsed = typeof value === 'string' ? parseISO(value) : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDateTimeBR = (value, pattern = 'dd/MM/yyyy HH:mm') => {
  const parsed = parseDateValue(value);
  return parsed ? format(parsed, pattern, { locale: ptBR }) : '--';
};

export const formatDateBR = (value, pattern = 'dd/MM/yyyy') => {
  const parsed = parseDateValue(value);
  return parsed ? format(parsed, pattern, { locale: ptBR }) : '--';
};

export const APP_TIME_ZONE = 'America/Sao_Paulo';

export const formatDateTimeSaoPaulo = (value) => {
  const parsed = parseDateValue(value);

  if (!parsed) {
    return '--';
  }

  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: APP_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(parsed).replace(',', '');
};

export const isTodayDate = (value) => {
  const parsed = parseDateValue(value);
  return parsed ? isSameDay(parsed, new Date()) : false;
};

export const normalizeSearch = (value) => (value || '').toString().trim().toLowerCase();

export const digitsOnly = (value) => (value || '').replace(/\D/g, '');

const NAME_PARTICLES = new Set(['de', 'da', 'das', 'do', 'dos', 'e']);

const capitalizeNameWord = (word) => word
  .split(/([-'])/)
  .map((part) => (part === '-' || part === "'" || !part ? part : `${part.charAt(0).toUpperCase()}${part.slice(1)}`))
  .join('');

export const formatPersonName = (value) => {
  const name = (value || '').toString().trim().replace(/\s+/g, ' ');

  if (!name) {
    return '';
  }

  return name
    .split(' ')
    .map((word, index) => {
      const lowerWord = word.toLowerCase();
      return index > 0 && NAME_PARTICLES.has(lowerWord) ? lowerWord : capitalizeNameWord(lowerWord);
    })
    .join(' ');
};
